module.exports = __webpack_public_path__ + "static/media/mert-buro-mockup.6929a74c.jpg";